
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from "../../payment/common/commonFunctions";
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { PROD } from "../../common/constants";
import { toast } from 'react-toastify';
import { Container, Card, CardContent, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { GET_DASHBOARD_INVENTORY_LIST, GET_UNRESTRICTED_INVENTORY } from "../../common/URLs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment';
import apiClient from "../../axios";

function InventoryLevel() {

    const navigate = useNavigate();
    const [inventoryCount, setInventoryCount] = useState();
    const [inventoryDetails, setInventoryDetails] = useState();
    const [searchFilter, setSearchFilter] = useState({
        "scheduleFrom": null,
        "scheduleTo": null,
        // "materialtype": null
    });

    useEffect(() => {
        getUnrestrictedInventory();
    }, []);

    const getUnrestrictedInventory = (e) => {
        loaderService.showLoader()
        apiClient
            .post(GET_UNRESTRICTED_INVENTORY,
                {
                    "stakeHolderUrn": getLocalStorageItem('urn'),
                    "stakeHolderType": getLocalStorageItem('stakeholderCategory'),
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setInventoryCount(response.data.inventoryMovementSum);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const columns = [
        {
            field: 'scheduleDate', headerName: 'Date', width: 130,
            valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'stakeholderType', headerName: 'Entity Type', width: 150 },
        { field: 'stakeholderUrn', headerName: 'Entity URN', width: 150 },
        { field: 'materialType', headerName: 'Material Type', width: 150 },
        { field: 'consignmentNo', headerName: 'Order No', width: 130 },
        { field: 'bundleId', headerName: 'Bundle ID', width: 220 },
        { field: 'inventoryMovement', headerName: 'Category', width: 150 },
        { field: 'inventoryType', headerName: 'Inventory Category', width: 150 },
        { field: 'weight', headerName: 'Weight', width: 100 },
        { field: 'moisture', headerName: 'Moisture', width: 150 },
        { field: 'uom', headerName: 'UOM.', width: 150 },
        { field: 'ordertype', headerName: 'Order Type', width: 150 },
    ];

    const onView = (materialType) => {
        loaderService.showLoader()
        apiClient
            .post(GET_DASHBOARD_INVENTORY_LIST,
                {
                    "stakeHolderUrn": getLocalStorageItem('urn'),
                    "stakeHolderType": getLocalStorageItem('stakeholderCategory'),
                    "materialType": materialType,
                    "inventoryCategory": "Unrestricted",
                    "scheduleFrom": searchFilter?.scheduleFrom,
                    "scheduleTo": searchFilter?.scheduleTo
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setInventoryDetails(response.data.inventories);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const handleFromDateChange = (e) => {
        setSearchFilter({ ...searchFilter, "scheduleFrom": e.format("YYYY-MM-DD") })
    }

    const handleToDateChange = (e) => {
        setSearchFilter({ ...searchFilter, "scheduleTo": e.format("YYYY-MM-DD") })
    }

    function searchInventoryDetails(e) {
        e.preventDefault();
        onView(inventoryDetails?.[0]?.materialType);
    }

    return (
        <>
            <Container maxWidth="xxl">
                <Typography variant="h5" gutterBottom>
                    Inventory Level
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={12}>
                        <Card>
                            <Table aria-label="simple table" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Total Raw Bamboo(MT)</TableCell>
                                        <TableCell align="center">Total Chipped Bamboo(MT)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="center" sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }} onClick={(e) => onView("RawBamboo")}>{inventoryCount?.unrestrictedRBInventory}</TableCell>
                                        <TableCell align="center" sx={{ cursor: "pointer", textDecoration: "underline", color: "blue" }} onClick={(e) => onView("ChipBamboo")}>{inventoryCount?.unrestrictedCBInventory}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Card>
                    </Grid>
                    {
                        inventoryDetails &&
                        <Grid item xs={12} lg={12}>
                            <Card>
                                <CardContent>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth >
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        label="Schedule From"
                                                        inputFormat="DD/MM/YYYY"
                                                        name="scheduleFrom"
                                                        onChange={(e) => handleFromDateChange(e)}
                                                        value={searchFilter?.scheduleFrom}
                                                        renderInput={(params) => <TextField size="small" {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth >
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        label="Schedule To"
                                                        inputFormat="DD/MM/YYYY"
                                                        name="scheduleTo"
                                                        minDate={searchFilter?.scheduleFrom || null}
                                                        onChange={(e) => handleToDateChange(e)}
                                                        value={searchFilter?.scheduleTo}
                                                        renderInput={(params) => <TextField size="small" {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <Button variant="contained" color="primary" onClick={(e) => searchInventoryDetails(e)} >
                                                Search
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
                                        {
                                            inventoryDetails &&
                                            <DataGrid rows={inventoryDetails}
                                                columns={columns}
                                                pageSize={10}
                                                getRowId={(row) => row.id}
                                                components={{ Toolbar: QuickSearchToolbar }}

                                            />
                                        }

                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    }

                </Grid>

            </Container>
            {/* <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmUpdate} onClose={handleConfirmClose} action="Update" /> */}
        </>
    );
}
export default InventoryLevel;
